import { RemoteTurnState } from "../../remote/turnState.js";
import type { TelegramActiveTurn } from "../turnRunner.js";

export class TelegramTurnState extends RemoteTurnState<TelegramActiveTurn> {}
